import React from "react";
import { Link } from "react-router-dom";
import ImageWithBasePath from "../../../core/img/imagewithbasebath";
import { all_routes } from "../../../Router/all_routes";

const QrCodeList = () => {
    const route = all_routes;
    return (
      <div className="main-wrapper">
        <div className="error-box">
          <div className="error-img">
            <ImageWithBasePath
              src="assets/img/authentication/under-maintenance.png"
              className="img-fluid"
              alt
            />
          </div>
          <h3 className="h2 mb-3">Page en Maintenance</h3>
          <p>
            Désolé, cette page est actuellement en maintenance. Nous travaillons dur pour la rendre disponible à nouveau. Merci de votre patience.
          </p>
          <Link to={route.signin} className="btn btn-primary">
            Retour à la page de connexion
          </Link>
        </div>
      </div>
    );
};

export default QrCodeList;
